import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ProtectedRoute from "./components/ProtectedRoute";
import Home from "./pages/Home";
import Careers from "./pages/Careers";
import Apply from "./pages/Apply";
import DriverOfTheWeek from "./pages/DriverOfTheWeek";
import About from "./pages/About";
import Contact from "./pages/Contact";
import AdminLogin from "./pages/AdminLogin";
import AvpUpload from "./pages/AvpUpload";
import ApplyAvp from "./pages/ApplyAvp";
import AvpLearnMore from "./pages/AvpLearnMore";
import AvpInterestResponse from "./pages/AvpInterestResponse";
import AvpDetails from "./pages/AvpDetails";
import JobPreviewResponse from "./pages/JobPreviewResponse";
import InterviewResponse from "./pages/InterviewResponse";
import OpsLayout from "./pages/ops/OpsLayout";
import OpsHome, { OpsPlaceholder } from "./pages/ops/OpsHome";
import DriverManagement from "./pages/ops/DriverManagement";
import ManagersAccess from "./pages/ops/ManagersAccess";
import UploadCenter from "./pages/ops/UploadCenter";
import Coaching from "./pages/ops/Coaching";
import Scorecard from "./pages/ops/Scorecard";
import WeeklyReview from "./pages/ops/WeeklyReview";
import VehicleHistory from "./pages/ops/VehicleHistory";
import DispatchLog from "./pages/ops/dispatch/DispatchLog";
import DispatchTasks from "./pages/ops/DispatchTasks";
import DispatchAccountability from "./pages/ops/DispatchAccountability";
import Personnel from "./pages/ops/Personnel";
import DriverDiscovery from "./pages/ops/DriverDiscovery";
import WeeklyReport from "./pages/ops/WeeklyReport";
import DriverSupport from "./pages/ops/support/DriverSupport";
import SupportInbox from "./pages/ops/support/SupportInbox";
import { ForgotPassword, ResetPassword } from "./pages/PasswordReset";
import AdminDashboard from "./pages/AdminDashboard";
import RecruitingPipeline from "./pages/RecruitingPipeline";
import { useEffect } from "react";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function PublicLayout() {
  return (
    <>
      <Navbar />
      <main><Outlet /></main>
      <Footer />
    </>
  );
}

function AdminLayout() {
  return (
    <>
      <Navbar />
      <main><Outlet /></main>
    </>
  );
}

export default function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <ScrollToTop />
          <Toaster position="top-right" theme="dark" richColors />
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/careers" element={<Careers />} />
              <Route path="/apply" element={<Apply />} />
              <Route path="/apply/avp" element={<ApplyAvp />} />
              <Route path="/avp" element={<AvpLearnMore />} />
              <Route path="/avp-interest/:token" element={<AvpInterestResponse />} />
              <Route path="/avp-interest/:token/:choice" element={<AvpInterestResponse />} />
              <Route path="/avp-details/:token" element={<AvpDetails />} />
              <Route path="/avp-upload/:token" element={<AvpUpload />} />
              <Route path="/job-preview/:token/:choice" element={<JobPreviewResponse />} />
              <Route path="/interview/:token" element={<InterviewResponse />} />
              <Route path="/interview/:token/:choice" element={<InterviewResponse />} />
              <Route path="/ops" element={<OpsLayout />}>
                <Route index element={<OpsHome />} />
                <Route path="support" element={<DriverSupport />} />
                <Route path="support/:channel" element={<SupportInbox />} />
                <Route path="drivers" element={<DriverManagement />} />
                <Route path="managers" element={<ManagersAccess />} />
                <Route path="uploads" element={<UploadCenter />} />
                <Route path="coaching" element={<Coaching />} />
                <Route path="weekly" element={<WeeklyReview />} />
                <Route path="vehicles" element={<VehicleHistory />} />
                <Route path="dispatch" element={<DispatchLog />} />
                <Route path="dispatch/tasks" element={<DispatchTasks />} />
                <Route path="dispatch/accountability" element={<DispatchAccountability />} />
                <Route path="personnel" element={<Personnel />} />
                <Route path="discovery" element={<DriverDiscovery />} />
                <Route path="weekly/report" element={<WeeklyReport />} />
                <Route path="drivers/:driverId/scorecard" element={<Scorecard />} />
                <Route path="settings" element={<OpsPlaceholder title="Operations Settings" text="Administrator-only service targets, ranking eligibility rules and production email switch (off by default). Available with Phase 2/3." />} />
              </Route>
              <Route path="/driver-of-the-week" element={<DriverOfTheWeek />} />
              <Route path="/driver-of-the-week/:id" element={<DriverOfTheWeek />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
            </Route>
            <Route element={<AdminLayout />}>
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/forgot-password" element={<ForgotPassword />} />
              <Route path="/admin/reset-password" element={<ResetPassword />} />
              <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
              <Route path="/admin/pipeline" element={<ProtectedRoute><RecruitingPipeline /></ProtectedRoute>} />
            </Route>
          </Routes>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}
